import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a9340df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "more-label" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = {
  key: 0,
  class: "frontend-icon fi-expand_less"
}
const _hoisted_4 = {
  key: 1,
  class: "frontend-icon fi-expand_more"
}

import { ref, watch } from "vue";
  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'score-item-show-more-button',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "mehr",
    },
  },
  emits: ["update:model-value"],
  setup(__props) {

  const props = __props;
  const value = ref<any>(props.modelValue);
  watch(()=>props.modelValue, (newValue)=>{
    value.value = newValue;
  })

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["components__score-item-show-more-button more", [_unref(themingCssClass)('normal')]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:model-value', !value.value)))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("span", _hoisted_2, [
      (value.value)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : (_openBlock(), _createElementBlock("i", _hoisted_4))
    ])
  ], 2))
}
}

})